import { Col, Row } from 'antd'
import React from 'react'

const CarDetailBox = ({ carDetails, bg = 'black' }) => {
    return (
        <Row className={`flex flex-wrap ${bg == 'black' ? 'text-white' : 'text-black'} justify-between items-center`}>
            <Col lg={4} className='flex  flex-col items-start gap-1'>
                <h3 className='text-sm font-semibold'>Make</h3>
                <span className='break-all text-xs'>{carDetails?.make ? carDetails?.make : '-'}</span>
            </Col>
            <Col className='h-9 border border-gray-400 m-2'></Col>
            <Col lg={6} className='flex flex-col items-start gap-1'>
                <h3 className='text-sm font-semibold'>Fuel Type</h3>
                <span className='break-all text-xs'>{carDetails?.fuelType ? carDetails?.fuelType : '-'}</span>
            </Col>
            <Col className='h-9 border border-gray-400 m-2'></Col>
            <Col lg={6} className='flex flex-col items-start gap-1'>
                <h3 className='text-sm font-semibold'>Engine Size</h3>
                <span className='break-all text-xs'>{carDetails?.engineSize ? carDetails?.engineSize : '-'}</span>
            </Col>
            <Col className='h-9 border border-gray-400 m-2'></Col>
            <Col lg={3} className='flex flex-col  items-start gap-1'>
                <h3 className='text-sm font-semibold'>Year</h3>
                <span className='break-all text-xs'>{carDetails?.year ? carDetails?.year : '-'}</span>
            </Col>
        </Row>
    )
}

export default CarDetailBox